import {
  HttpClient, HttpHeaders,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  lastValueFrom,
  timeout,
} from 'rxjs';
import { apiConfiguration } from '../../../../../configurations/api-configuration';
import { AccessService } from '../../../services/AccessService';
import { HttpResponse } from '../../../types/HttpResponse';

export type MinioCheckStatus = 'online' | 'protected' | 'offline' | 'unknown';

export interface MinioHealthCheck {
  id: string;
  label: string;
  url: string | null;
  status: MinioCheckStatus;
  statusCode: number | null;
  latencyMs: number | null;
  detail: string;
}

export interface MinioConfigurationItem {
  label: string;
  value: string;
  state: 'ready' | 'attention' | 'missing';
}

export interface MinioAccessInfo {
  consoleUrl: string | null;
  s3Endpoint: string | null;
  bucket: string | null;
  region: string;
  allowedIp: string | null;
  viewerIp: string | null;
  viewerAllowed: boolean | null;
  uploaderAccessKeyId: string | null;
  secretKeyAvailable: boolean;
  secretKeyReference: string;
}

export interface MinioStatus {
  configured: boolean;
  bucket: string | null;
  region: string;
  internalEndpoint: string | null;
  publicEndpoint: string | null;
  consoleUrl: string | null;
  adminAllowedIp: string | null;
  credentialsConfigured: boolean;
  checkedAt: string;
  checks: MinioHealthCheck[];
  configuration: MinioConfigurationItem[];
  access: MinioAccessInfo;
}

@Injectable()
export class MinioDashboardApiService {
  private readonly minioUrl = `${apiConfiguration.baseApiUrl}/minio`;

  public constructor(
    private http: HttpClient,
    private accessService: AccessService,
  ) { }

  public getStatus(): Promise<HttpResponse<MinioStatus>> {
    return lastValueFrom(this.http.get<HttpResponse<MinioStatus>>(`${this.minioUrl}/status`, { headers: this.getHeaders() })
      .pipe(timeout(8000)));
  }

  private getHeaders(): HttpHeaders {
    let token = this.accessService.getToken();
    if (!token) {
      this.accessService.initialize();
      token = this.accessService.getToken();
    }

    return token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : new HttpHeaders();
  }
}
